export * from './misc';
export * from './location';

import { env } from '@zyf2e/adapt';

// eslint-disable-next-line import/prefer-default-export
export function getCommonApi(apiUrl: string, port: number, rootUrl = '/'): string {
  const { devEnv } = env;
  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
  const baseApi = `${protocol}//${apiUrl}${devEnv ? `.${devEnv}` : ''}.91jkys.com`;

  return baseApi + (port && port !== 80 ? `:${port}` : '') + rootUrl;
}

export function getQueryVariable(variable: string) {
  const query = window.location.href.split('?');
  if (query.length < 2) {
    return null;
  }
  const vars = query[1].split('&');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return null;
}

export function parseParam(json: { [prop: string]: string }) {
  return Object.keys(json)
    .flatMap(v => {
      if (/^https?:\/\//.test(json[v])) {
        return [`${v}=${encodeURIComponent(json[v])}`];
      }
      if (!json[v]) return [];
      return [`${v}=${json[v]}`];
    })
    .join('&');
}

export function isSecretModel() {
  const storage = window.localStorage;
  try {
    storage.setItem('localCookie', document.cookie);
    return storage.getItem('localCookie');
  } catch (error) {
    return true;
  }
  return false;
}

export const adaptConfig = {
  INSURANCE: {
    baseURL: process.env.VUE_APP_INSURANCE_API,
    loginKey: process.env.VUE_APP_INSURANCE_LOGIN_KEY,
    wechatLoginApi: process.env.VUE_APP_INSURANCE_LOGIN_API,
    h5LoginUrl: `${process.env.VUE_APP_INSURANCE_H5LOGIN_URL}#/login?c=${getQueryVariable('city')}&redirect=`,
    jkysWechatURL: `${process.env.VUE_APP_INSURANCE_API}cis_base/1.0/get_wxconfig?c=${getQueryVariable('city')}`
  },
  MEDIC_SALE: {
    baseURL: process.env.VUE_APP_MEDIC_SALE_API,
    loginKey: process.env.VUE_APP_MEDIC_SALE_LOGIN_KEY,
    wechatLoginApi: process.env.VUE_APP_MEDIC_SALE_LOGIN_API,
    jkysWechatURL: `${process.env.VUE_APP_MEDIC_SALE_API}medicsale_patient/1.0/share_config`
  }
};
